import { useEffect, useState } from "react";
import QuestionScreen from "./Screens/QuestionScreen/QuestionScreen";
import { SelectedAnswer } from "./Screens/QuestionScreen/QuestionScreen";
import LeadModal from "../BehaviourAnalysisResult/components/LeadModal";
import { postBloomreachAnalysisLead, postBloomreachLead, postBloomreachPreAnalysisLead } from "../../utils/api";
import { BloomreachAnalysisLeadModel } from "../../types/BloomreachAnalysisLeadModel";
import { BloomreachLeadModel } from "../../types/BloomreachLeadModal";
import { BloomreachPreAnalysisLeadModel } from "../../types/BloomreachPreAnalysisLeadModel";
import { getCookie } from "../../utils/cookieService";
import Analytics from "../../utils/analytics";
import { FadeInWrapper, LeadGateContainer, TransitionRoot } from "./BehaviourAnalysisMini.style";

export enum types {
  tryghed = "tryghed",
  struktur = "struktur",
  relation = "relation",
  balance = "balance",
  fremdrift = "fremdrift",
}

type BehaviourResult = {
  dominantType: types;
  countsByType: Record<types, number>;
  percentagesByType: Record<types, number>;
};

export const questions = [
  {
    id: 1,
    question: "Når du står overfor en vigtig beslutning, hvad gør du typisk først?",
    order: 1,
    answers: [
      { id: "a1", answer: "Jeg undersøger, hvilke konsekvenser de forskellige muligheder kan få.", value: types.tryghed },
      { id: "a2", answer: "Jeg samler information og forsøger at få et klart overblik.", value: types.struktur },
      { id: "a3", answer: "Jeg vender mine tanker med andre for at få flere perspektiver.", value: types.relation },
      { id: "a4", answer: "Jeg ser på, hvordan beslutningen påvirker situationen som helhed.", value: types.balance },
      { id: "a5", answer: "Jeg fokuserer på, hvilken løsning der bringer os hurtigst videre.", value: types.fremdrift },
    ],
  },
  {
    id: 2,
    question: "Hvad vægter du højest, når du skal vælge mellem flere muligheder?",
    order: 2,
    answers: [
      { id: "b1", answer: "At det virker robust på længere sigt.", value: types.tryghed },
      { id: "b2", answer: "At der er en tydelig plan for, hvordan den skal gennemføres.", value: types.struktur },
      { id: "b3", answer: "At de involverede personer kan se sig selv i beslutningen.", value: types.relation },
      { id: "b4", answer: "At forskellige hensyn bliver afvejet på en fornuftig måde.", value: types.balance },
      { id: "b5", answer: "At det skaber synlige resultater.", value: types.fremdrift },
    ],
  },
  {
    id: 3,
    question: "Hvis noget er uklart, hvad gør du typisk?",
    order: 3,
    answers: [
      { id: "c1", answer: "Jeg afklarer, hvad der kan gå galt, før jeg fortsætter.", value: types.tryghed },
      { id: "c2", answer: "Jeg søger efter information eller konkrete retningslinjer.", value: types.struktur },
      { id: "c3", answer: "Jeg taler med relevante personer for at få deres input.", value: types.relation },
      { id: "c4", answer: "Jeg forsøger at skabe et samlet billede af situationen.", value: types.balance },
      { id: "c5", answer: "Jeg tager de første skridt og justerer undervejs.", value: types.fremdrift },
    ],
  },
  {
    id: 4,
    question: "Hvilken type feedback oplever du som mest værdifuld?",
    order: 4,
    answers: [
      { id: "e1", answer: "Feedback der hjælper mig med at undgå fejl.", value: types.tryghed },
      { id: "e2", answer: "Feedback der giver mig klarhed og retning.", value: types.struktur },
      { id: "e3", answer: "Feedback der bygger på andres erfaringer.", value: types.relation },
      { id: "e4", answer: "Feedback der hjælper mig med at se flere sider af sagen.", value: types.balance },
      { id: "e5", answer: "Feedback der peger på næste skridt.", value: types.fremdrift },
    ],
  },
  {
    id: 5,
    question: "Hvad hjælper dig mest, når du oplever pres?",
    order: 5,
    answers: [
      { id: "i1", answer: "At vide, hvad jeg kan regne med.", value: types.tryghed },
      { id: "i2", answer: "At få styr på processen.", value: types.struktur },
      { id: "i3", answer: "At sparre med andre.", value: types.relation },
      { id: "i4", answer: "At prioritere og skabe overblik.", value: types.balance },
      { id: "i5", answer: "At tage fat på det vigtigste med det samme.", value: types.fremdrift },
    ],
  },
  {
    id: 6,
    question: "Når der sker større forandringer, hvad er din første reaktion?",
    order: 6,
    answers: [
      { id: "k1", answer: "Jeg overvejer, hvilke konsekvenser de kan få.", value: types.tryghed },
      { id: "k2", answer: "Jeg forsøger at forstå planen bag ændringerne.", value: types.struktur },
      { id: "k3", answer: "Jeg tænker på, hvordan de påvirker andre omkring mig.", value: types.relation },
      { id: "k4", answer: "Jeg prøver at se både muligheder og udfordringer.", value: types.balance },
      { id: "k5", answer: "Jeg bliver nysgerrig på, hvad de kan føre til.", value: types.fremdrift },
    ],
  },
  {
    id: 7,
    question: "Hvad giver dig mest energi i hverdagen?",
    order: 7,
    answers: [
      { id: "l1", answer: "At skabe noget holdbart og stabilt.", value: types.tryghed },
      { id: "l2", answer: "At skabe orden og sammenhæng.", value: types.struktur },
      { id: "l3", answer: "At bidrage til gode relationer og fællesskab.", value: types.relation },
      { id: "l4", answer: "At finde løsninger, der fungerer for alle.", value: types.balance },
      { id: "l5", answer: "At nå mål og skabe resultater.", value: types.fremdrift },
    ],
  },
  {
    id: 8,
    question: "Hvad kan frustrere dig mest i hverdagen?",
    order: 8,
    answers: [
      { id: "p1", answer: "Når ting ændrer sig uden varsel.", value: types.tryghed },
      { id: "p2", answer: "Når der mangler struktur eller retning.", value: types.struktur },
      { id: "p3", answer: "Når samarbejdet ikke fungerer.", value: types.relation },
      { id: "p4", answer: "Når vigtige hensyn bliver overset.", value: types.balance },
      { id: "p5", answer: "Når tingene står stille for længe.", value: types.fremdrift },
    ],
  },
  {
    id: 9,
    question: "Hvordan lærer du bedst noget nyt?",
    order: 9,
    answers: [
      { id: "t1", answer: "Når jeg får tid og ro til at forstå det i mit eget tempo.", value: types.tryghed },
      { id: "t2", answer: "Når læringen er bygget logisk op og nem at følge.", value: types.struktur },
      { id: "t3", answer: "Når jeg kan tale med andre om det og dele erfaringer.", value: types.relation },
      { id: "t4", answer: "Når jeg forstår helheden og hvorfor det er vigtigt.", value: types.balance },
      { id: "t5", answer: "Når jeg får lov til selv at afprøve det i praksis.", value: types.fremdrift },
    ],
  },
  {
    id: 10,
    question: "Hvilken egenskab værdsætter du mest hos en person, der tager ansvar?",
    order: 10,
    answers: [
      { id: "u1", answer: "Evnen til at skabe trygge rammer.", value: types.tryghed },
      { id: "u2", answer: "Evnen til at skabe en klar retning.", value: types.struktur },
      { id: "u3", answer: "Evnen til at inkludere og involvere andre.", value: types.relation },
      { id: "u4", answer: "Evnen til at tage hensyn til forskellige behov.", value: types.balance },
      { id: "u5", answer: "Evnen til at få ting til at ske.", value: types.fremdrift },
    ],
  },
  {
    id: 11,
    question: "Hvad kendetegner et godt miljø for dig?",
    order: 11,
    answers: [
      { id: "w1", answer: "At der er gensidig tillid.", value: types.tryghed },
      { id: "w2", answer: "At roller og forventninger er tydelige.", value: types.struktur },
      { id: "w3", answer: "At man hjælper og støtter hinanden.", value: types.relation },
      { id: "w4", answer: "At der er plads til forskellige meninger.", value: types.balance },
      { id: "w5", answer: "At der er energi og udvikling.", value: types.fremdrift },
    ],
  },
];

const pages = questions.map((question) => ({ id: question.id, questionId: question.id }));

export default function BehaviourAnalysis() {
  const [resultUrl, setResultUrl] = useState<string | null>(null);
  const [situationUrl, setSituationUrl] = useState<string | null>(null);
  const [showLeadGate, setShowLeadGate] = useState(false);
  const [leadSubmitted, setLeadSubmitted] = useState(false);
  const [showQuestion, setShowQuestion] = useState(false);
  const [result, setResult] = useState<SelectedAnswer[] | null>(null);
  //const [resultType, setResultType] = useState<types | null>(null);
  const [countByType, setCountByType] = useState<Record<types, number> | null>(null);
  const [percentagesByType, setPercentagesByType] = useState<Record<types, number> | null>(null);
  const [cookieAnswered, setCookieAnswered] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [leadContact, setLeadContact] = useState<Pick<BloomreachAnalysisLeadModel, "firstName" | "email" | "phone"> | null>(null);

  //Check for window size
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 750);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //Check if cookuehub has been answered
  useEffect(() => {
    if ((window as any).cookiehub?.hasAnswered()) {
      setCookieAnswered(true);
      return;
    }
    const interval = setInterval(() => {
      if ((window as any).cookiehub?.hasAnswered()) {
        setCookieAnswered(true);
        clearInterval(interval);
      }
    }, 200);
    return () => clearInterval(interval);
  }, []);

  //Get data-result-url
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resultUrl = form?.dataset.resultUrl;
        if (resultUrl) {
          setResultUrl(resultUrl);
        }
      } catch (err) {}
    };

    const form = document.querySelector(`[data-component='behaviour-analysis-mini']`) as HTMLElement;

    fetchData();
  }, []);

  //Get url params for situation
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const situation = urlParams.get("situation");

    if (situation) {
      setSituationUrl(situation);
    } else {
      setSituationUrl("salary");
    }
  }, []);

  //Show lead gate directly once the cookie overlay has been dismissed
  useEffect(() => {
    const hasUrlParams = new URLSearchParams(window.location.search).toString().length > 0;

    if (hasUrlParams) {
      setShowLeadGate(true);
      return;
    }

    if (!cookieAnswered) return;

    setShowLeadGate(true);
    Analytics.getInstance().trackBehaviourProfiling("behaviour_start", "behavioral", "start");
  }, [cookieAnswered]);

  //Handle lead gate submission - captures contact info before the questions are shown
  const handleSendLead = async (leadData: Pick<BloomreachAnalysisLeadModel, "firstName" | "email" | "phone">) => {
    const lead: BloomreachLeadModel = {
      firstName: leadData.firstName,
      lastName: "",
      email: leadData.email,
      phone: leadData.phone,
      occupation: "",
      campaign: "Adfærdsanalyse",
      source: "Adfærdsanalyse mini",
      comment: "",
      cookie: getCookie("__exponea_etc__") ?? "",
    };

    await postBloomreachLead(lead).then(() => {
      setLeadContact(leadData);
      setLeadSubmitted(true);
      setShowLeadGate(false);
      setShowQuestion(true);
    });
  };

  //Result calculation
  const calculateBehaviourResult = (answers: SelectedAnswer[]) => {
    setResult(answers);

    const allTypes = Object.values(types);
    const countsByType = allTypes.reduce(
      (acc, type) => {
        acc[type] = 0;
        return acc;
      },
      {} as Record<types, number>,
    );

    answers.forEach((answer) => {
      countsByType[answer.type] += 1;
    });

    const typeTiebreakerPriority: types[] = [types.balance, types.tryghed, types.struktur, types.relation, types.fremdrift];

    const dominantType = allTypes.reduce((currentMaxType, nextType) => {
      const countDiff = countsByType[nextType] - countsByType[currentMaxType];

      if (countDiff !== 0) {
        return countDiff > 0 ? nextType : currentMaxType;
      }

      const nextTypePriority = typeTiebreakerPriority.indexOf(nextType);
      const currentMaxTypePriority = typeTiebreakerPriority.indexOf(currentMaxType);

      return nextTypePriority < currentMaxTypePriority ? nextType : currentMaxType;
    }, allTypes[0]);

    const totalAnswers = questions.length;
    const calculatedPercentagesByType = allTypes.reduce(
      (acc, type) => {
        acc[type] = totalAnswers > 0 ? Number(((countsByType[type] / totalAnswers) * 100).toFixed(2)) : 0;
        return acc;
      },
      {} as Record<types, number>,
    );

    //setResultType(dominantType);
    setCountByType(countsByType);
    setPercentagesByType(calculatedPercentagesByType);

    // tracking result
    Analytics.getInstance().trackBehaviourProfiling("behaviour_result", "behavioral", dominantType);
    //console.log("%type", calculatedPercentagesByType);
    Object.entries(calculatedPercentagesByType).forEach(([type, percentage]) => {
      //console.log("tracking", type, percentage);
      Analytics.getInstance().trackBehaviourProfiling("behavioral_procents", "behavioral", `${type}_${percentage}`);
    });

    sendResult(dominantType, calculatedPercentagesByType);
  };

  //Handle sending result
  const sendResult = async (dominantType: types, calculatedPercentagesByType: Record<types, number>) => {
    if (resultUrl) {
      const cookie = getCookie("__exponea_etc__");
      if (cookie) {
        // cookie check for pre-analysis lead submission, if cookie exists submit pre-analysis lead and then redirect to result page, if not just redirect to result page
        let lead = {} as BloomreachPreAnalysisLeadModel;
        lead.campaign = "Adfærdsanalyse";
        lead.cookie = cookie;
        lead.situation = situationUrl || "salary";
        lead.profiletype = dominantType;
        lead.safetyScore = calculatedPercentagesByType.tryghed;
        lead.structureScore = calculatedPercentagesByType.struktur;
        lead.balanceScore = calculatedPercentagesByType.balance;
        lead.relationScore = calculatedPercentagesByType.relation;
        lead.firstmoverScore = calculatedPercentagesByType.fremdrift;
        await postBloomreachPreAnalysisLead(lead).then(async () => {
          //Now that the profiletype is known, send the full analysis lead so the result email is correct
          if (leadContact) {
            await postBloomreachAnalysisLead({
              ...leadContact,
              campaign: "Adfærdsanalyse",
              source: "Adfærdsanalyse mini",
              cookie,
              situation: situationUrl || "salary",
              profiletype: dominantType,
            });
          }
          let resultUrlWithParams = `${resultUrl}/?situation=${situationUrl}&resultType=${dominantType}&leadSubmitted=${leadSubmitted}`;
          window.location.href = resultUrlWithParams;
          Analytics.getInstance().trackBehaviourProfilingCta(dominantType, resultUrlWithParams, "Se resultat");
        });
      } else {
        let resultUrlWithParams = `${resultUrl}/?situation=${situationUrl}&resultType=${dominantType}&leadSubmitted=${leadSubmitted}`;
        window.location.href = resultUrlWithParams;
        Analytics.getInstance().trackBehaviourProfilingCta(dominantType, resultUrlWithParams, "Se resultat");
      }
    }
  };

  return (
    <TransitionRoot>
      {showQuestion && (
        <FadeInWrapper>
          <QuestionScreen questions={questions} pages={pages} onResult={(answers) => calculateBehaviourResult(answers)} />
        </FadeInWrapper>
      )}
      {showLeadGate && !showQuestion && (
        <FadeInWrapper>
          <LeadGateContainer>
            <LeadModal
              isDesktop={isDesktop}
              onSendLead={handleSendLead}
              title="Start din adfærdsanalyse"
              text="Forstå dig selv bedre, og få konkrete råd til netop din profil - så du lettere kan styrke dine resultater både privat og på arbejdet."
              buttonText="Start din adfærdsanalyse"
            />
          </LeadGateContainer>
        </FadeInWrapper>
      )}
    </TransitionRoot>
  );
}
